import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRegions } from "../store/user/thunks";

export const useRegions = () => {
  const dispatch = useDispatch();
  const regions = useSelector((state) => state.user.regions);

  useEffect(() => {
    if (!regions) {
      dispatch(getRegions());
    }
  }, [regions, dispatch]);

  const regionsOptions = useMemo(() => {
    return (
      regions?.map((r) => ({
        value: r.id,
        label: `${r?.region_name} (${r?.region_code})`,
      })) || []
    );
  }, [regions]);

  return { regions: regions || [], regionsOptions };
};
